import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { NGXLogger } from 'ngx-logger';
import { map, switchMap } from 'rxjs';

import { LogoutDialogActions } from './logout-dialog.actions';

@Injectable()
export class LogoutDialogEffects {

  constructor(
    private readonly actions$: Actions,
    private readonly oidcSecurityService: OidcSecurityService,
    private readonly logger: NGXLogger,
  ) {}

  confirm$ = createEffect(
    () => this.actions$.pipe(
      ofType(LogoutDialogActions.confirm),
      switchMap(() =>
        this.oidcSecurityService.logoff().pipe(
          map(() => LogoutDialogActions.close()),
        ),
      ),
    ),
  );
}
